<script setup lang="ts">
const emit = defineEmits<{
  (event: 'close'): void
}>()

const handleClose = () => {
  emit('close')
}
</script>

<template>
  <div class="header__close">
    <v-btn
      data-cy="toolbar_base_close_btn"
      class="close-btn"
      variant="text"
      :aria-label="$t('global.close')"
      @click="handleClose"
    >
      <v-icon size="24">custom:c_close</v-icon>
    </v-btn>
  </div>
</template>

<style lang="scss" scoped>
.header__close {
  width: 90px;
  min-height: $siteheader-height;
  height: $siteheader-height;
  margin: 0;
  position: sticky;
  top: 0;

  .close-btn {
    width: 100%;
    height: 100%;
  }
}
</style>
